((window.greenleazeScript = !0),
  (window.initGreenleazeScript = !1),
  (window.initPriceGreenleaze = !1));
var monthValues = [1, 12, 24, 36],
  rawrules = {},
  formated = {},
  priceRules = [];
let isCart = !1,
  tva = 1.2,
  trackingId = null;
const greenleazePriceActualize = new Event('greenleazePriceActualize');
function parseRule(e, r) {
  return new Function('return ' + e.replace(/\[\[(\w+)\]\]/g, (e, t) => r[t]));
}
function getAllPricesForProduct(e) {
  const r = {};
  for (const t of monthValues) r[t] = getRuleByProductPriceAndDuration(e, t);
  return r;
}
function getRuleByProductPriceAndDuration(e, r = 36) {
  (monthValues.includes(r) || (r = monthValues[monthValues.length - 1]),
    (productPriceFormat = parseFloat(e)));
  const t = priceRules.find(
    (e) =>
      e.duration == r &&
      e.minPrice <= productPriceFormat &&
      e.maxPrice >= productPriceFormat,
  );
  if (!t)
    return (
      console.error('No price rule found', priceRules),
      getAllPriceRules(),
      null
    );
  const n = parseRule(t.rule, { tva: tva, prixHT: e }),
    o = parseRule(t.depositRule, { tva: tva, prixHT: e });
  return t
    ? { monthly: n(), initial: o() }
    : { monthly: '0.00', initial: '0.00' };
}
async function getAllPriceRules() {
  const e = await fetch('/apps/greenleaze-proxy/pricing', {
    method: 'GET',
    headers: {
      'ngrok-skip-browser-warning': 'true',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  });
  ((rawrules = await e.json()), (priceRules = rawrules));
  const r = new Set();
  for (let t = 0; t < priceRules.length; t++) r.add(priceRules[t].duration);
  ((monthValues = [...r].sort(function (e, r) {
    return e - r;
  })),
    (window.initPriceGreenleaze = !0),
    console.log('GREENLEAZE INITIALIZED'),
    window.dispatchEvent(greenleazePriceActualize),
    document.addEventListener('on:cart:add', function (e) {
      (console.log('product added'),
        setTimeout(() => window.dispatchEvent(greenleazePriceActualize), 1500));
    }),
    document.addEventListener('on:line-item:change', function (e) {
      (console.log('product changed'),
        setTimeout(() => window.dispatchEvent(greenleazePriceActualize), 1500));
    }),
    document.addEventListener('dispatch:cart-drawer:refresh', function (e) {
      (console.log('dispatch:cart-drawer:refresh'),
        setTimeout(() => window.dispatchEvent(greenleazePriceActualize), 1500));
    }),
    document.addEventListener('on:cart:error', function (e) {
      (console.log('on:cart:error'),
        setTimeout(() => window.dispatchEvent(greenleazePriceActualize), 1500));
    }));
}
async function addTo(e, r) {
  var t = { id: e, quantity: r };
  try {
    let e = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(t),
    });
    if (!e.ok) throw new Error('Error during request: ' + e.statusText);
    await e.json();
  } catch (n) {
    console.error('Erreur:', n);
  }
}
async function sendCartAndRedirect(e, r, t) {
  let n = await fetch(window.Shopify.routes.root + 'cart.js'),
    o = await n.json();
  if (r) {
    o.items.some((e) => e.variant_id == r) ||
      (await addTo(r, 1),
      console.log(''),
      (n = await fetch(window.Shopify.routes.root + 'cart.js')),
      console.log(''),
      (o = await n.json()));
  }
  trackingId ||
    (trackingId =
      window.ShopifyAnalytics?.lib?.user?.()?.traits?.()?.uniqToken ||
      self?.crypto?.randomUUID?.());
  let i = await fetch('/apps/greenleaze-proxy/send-card', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
    body: JSON.stringify({
      cartContents: JSON.stringify(o),
      duration: e,
      trackingId: trackingId,
      trackingData: null,
      postHogtrackingId: t,
    }),
  });
  if (!i.ok) {
    (console.error("Une erreur s'est produite."),
      console.error('error during saved ', i));
    let e = "Une erreur s'est produite.";
    try {
      ((i = await i.json()), (e = i?.message || "Une erreur s'est produite."));
    } catch (a) {
      (console.error("Une erreur s'est produite."),
        console.error('error during saved ', i));
    }
    return (
      window.postMessage({ type: 'greenleazeError', message: e }, '*'),
      !1
    );
  }
  return (
    (i = await i.json()),
    i?.message
      ? (console.error(i?.message),
        window.postMessage(
          { type: 'greenleazeError', message: i?.message },
          '*',
        ),
        !1)
      : i?.redirectUrl
        ? ((window.location.href = i?.redirectUrl + '&duration=' + e), !0)
        : void 0
  );
}
async function initGreenleaze() {
  (console.log('INITIALIAZING GREENLEAZE'),
    (window.initGreenleazeScript = !0),
    await getAllPriceRules());
}
(window.initGreenleazeScript || initGreenleaze(),
  window.addEventListener('message', function (e) {
    (console.log(e),
      'submitGreenleazeModal' === e.data.type &&
        sendCartAndRedirect(
          e.data?.duration,
          e.data?.variantId,
          e.data?.pdistinctId,
        ).then((e) => {
          e &&
            (document.querySelector(
              '#modal-abonnement-product--greenleaze',
            ).style.display = 'none');
        }));
  }));
